import {
  Required,
  IsString,
  IsNumber,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface MaterialTagListResponse {
  list: {
    create_time: number;
    folder_id: number;
    id: number;
    material_count: number;
    tag_name: string;
    update_time: number;
    user_id: number;
  };
}

// 嵌套对象类
export class MaterialTagData {
  @Required("ID cannot be empty")
  @IsNumber("ID must be a number")
  id: number;

  @Required("Folder ID cannot be empty")
  @IsNumber("Folder ID must be a number")
  folderId: number;

  @Required("Tag name cannot be empty")
  @IsString("Tag name must be a string")
  tagName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;

  // @Required("Material count cannot be empty")
  @IsNumber("Material count must be a number")
  materialCount: number;
}

// 主数据类
export class MaterialTagListData {
  @Required("List cannot be empty")
  @ValidateNested(MaterialTagData)
  list: MaterialTagData[];
}

const transformAndValidateMaterialTagList = (
  response: MaterialTagListResponse
): MaterialTagListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, MaterialTagListData);
  } catch (error) {
    console.error("Material tag list data validation failed:", error.message);
    throw error;
  }
};

// 素材标签列表
export const materialTagList = async (folderId?: number): Promise<MaterialTagListData> => {
  const url = folderId ? `/material_tag/list?folder_id=${folderId}&page=1&page_size=200` : '/material_tag/list?page=1&page_size=500';
  const res = await api.get<MaterialTagListResponse>(url);
  const validatedData = transformAndValidateMaterialTagList(res.data);
  return validatedData;   
};
